<!-- 重仓债券列表 -->
<template>
  <div class="heavy-bond-list">
    <!-- 顶部重仓 -->
    <div class="top row">
      <p class="top-tip"><span class="dot"></span>
        <span
        >重仓债券</span><span class="stock-value">{{dataSource.allHoldRatio || '--'}}</span>
      </p>
      <div class="date">{{dataSource.holdDate || '--'}}</div>
    </div>
    <!-- 持仓列表 -->
    <common-list
      :header-list="headerList"
      :data-source="getDataList()"
      :more-text="'更多持仓信息'"
      :click-track="'xpzy.pzy.gdccxx.click'">
      <template slot="list-item" slot-scope="{item}">
        <div class="row list-item">
          <!-- 债券名称 -->
          <div class="bond-name">
            <div>{{item.bondName}}</div>
            <div class="row bond-tags">
              <div v-if="!$isEmpty(item.marketTag)" class="market-tag">{{item.marketTag}}</div>
              <div v-if="!$isEmpty(item.indexName)" class="index-tag">{{item.indexName}}</div>
            </div>
          </div>
          <div class="price-column">
            <div v-if="!$isEmpty(item.marketTip)" class="price-tip">{{item.marketTip}}</div>
            <div :style="{ color: getRateColor(item.priceRatio)}" class="price-tip"
              >{{item.price || '--'}}</div>
            <div :style="{ color: getRateColor(item.priceRatio) }" class="price-ratio"
              >{{item.priceRatio || '--'}}</div>
          </div>
          <!-- 持仓占比 -->
          <div class="hold-column">{{item.holdRatio}}</div>
          <div class="last-column">
            <div class="previous-box row">
              <img v-if="['新增','不变'].indexOf(item.compareWithPrevious) < 0
                && !$isEmpty(item.compareWithPrevious)"
                :src="parseFloat(item.compareWithPrevious) > 0 ? UP_ARROW : DOWN_ARROW"
                class="arrow" />
              <div>{{getPreviousValue(item.compareWithPrevious)}}</div>
            </div>
            <div v-if="!$isEmpty(item.holdCount)" class="hold-count">{{item.holdCount}}</div>
          </div>
        </div>
      </template>
    </common-list>
  </div>
</template>

<script>
import CONFIG from '@/configs/default';
import tool from '@/utils/tool';
import CommonList from '../MarketQuotation/QuotationCommonList.vue';

export default {

  name: 'heavy-bond-list',

  components: {
    CommonList,
  },

  props: {
    dataSource: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      headerList: CONFIG.heavyBondListHeader || [],
      UP_ARROW: 'https://j5.dfcfw.com/sc/image/202208/20220815030116.png',
      DOWN_ARROW: 'https://j5.dfcfw.com/sc/image/202208/20220815030127.png',
    };
  },

  methods: {

    getRateColor: tool.getRateColor,

    async getDataList() {
      return this.dataSource.list;
    },

    getPreviousValue(value) {
      if (['新增', '不变'].indexOf(value) >= 0) return value;
      if (this.$isEmpty(value) || this.$isEmpty(parseFloat(value))) return '--';
      try {
        return `${Math.abs(parseFloat(value)).toFixed(2)}%`;
      } catch (error) {
        return '--';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.heavy-bond-list {
  width: 100%;
  box-sizing: border-box;
  padding-right: 24px;
  margin-top: 30px;
  .top {
    justify-content: space-between;
    font-family: DINAlternate-Bold;
    color: #000000;
    .top-tip {
      font-size: 30px;
      line-height: 38px;
      height: 38px;
      margin: 0;
      .dot {
        display: inline-block;
        width: 10px;
        height: 10px;
        background-color: #f96b36;
        border-radius: 5px;
        margin-right: 8px;
        margin-bottom: 8px;
      }
      .stock-value {
        font-size: 32px;
        letter-spacing: 0;
        line-height: 40px;
        text-align: center;
        margin-left: 24px;
      }
    }
    .date {
      font-size: 28px;
      color: #999999;
      letter-spacing: 0;
      text-align: right;
      line-height: 36px;
    }
  }
  .list-item {
    justify-content: space-between;
    padding: 16px 0 24px;
    .bond-name {
      flex: 5;
      font-size: 30px;
      color: #000000;
      letter-spacing: 0;
      line-height: 30px;
      .bond-tags {
        justify-content: flex-start;
        .market-tag {
          margin-top: 8px;
          font-size: 24px;
          color: #666666;
          text-align: center;
          margin-right: 16px;
        }
        .index-tag {
          margin-top: 8px;
          background-color: rgba(102, 102, 102, 0.1);
          border-radius: 4px;
          font-size: 20px;
          color: #666666;
          text-align: center;
          padding: 4px 8px 4px 8px;
        }
      }
    }
    .price-column {
      flex: 4;
      font-family: DINAlternate-Bold;
      font-size: 32px;
      text-align: center;
      .price-tip {
        color: #000000;
      }
      .price-ratio {
        font-size: 26px;
        margin-top: 8px;
      }
    }
    .hold-column {
      flex: 3;
      font-family: DINAlternate-Bold;
      font-size: 32px;
      color: #000000;
      text-align: center;
    }
    .last-column {
      flex: 3;
      font-family: DINAlternate-Bold;
      font-size: 30px;
      color: #000000;
      text-align: right;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .previous-box {
        justify-content: flex-end;
        .arrow {
          width: 12px;
          height: 19px;
          margin-right: 8px;
        }
      }
      .hold-count {
        font-size: 20px;
        color: #666666;
        font-weight: 400;
        background: rgba(102, 102, 102,0.1);
        border-radius: 4px;
        padding: 4px 8px;
        margin-top: 12px;
      }
    }
  }
}
</style>
